import { Environment, RecordSource, Store } from "relay-runtime";
import { defaultConfig } from "~/lib/config";
import { network } from "./network";
export function createEnvironment(networkOptions = {
  authOptions: {
    allowEmptyToken: true
  },
  urlOptions: {
    headers: {
      apikey: defaultConfig.graphql.apiKey
    },
    method: "POST",
    url: defaultConfig.graphql.host
  }
}, environmentConfig = {}, recordMap) {
  return new Environment({
    ...environmentConfig,
    network: network(networkOptions),
    store: new Store(new RecordSource(recordMap))
  });
}